/** @format */

import React from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import styled from 'src/ui/library/styled';
import Moment from 'moment';
import { formatDate, parseDate } from 'react-day-picker/moment';
import DatePickerInput from './DatePickerInput';
import DatePickerHeader from './DatePickerHeader';
import 'react-day-picker/lib/style.css';

const styles = theme => ({
  root: {},
  overlay: {
    height: '0px',
  },
  '@global': {
    '.DayPicker': {
      position: 'relative',
    },
    '.DayPicker-wrapper': {
      position: 'absolute',
      top: '-13px',
      zIndex: 1000,
      border: `1px solid ${theme.colors.eyGrey6}`,
      backgroundColor: '#FFF',
    },
    '.DayPicker-Weekdays': {
      display: 'none',
    },
    '.DayPicker-Body ': {
      display: 'block',
    },
    '.DayPickerInput-OverlayWrapper': {
      zIndex: 1000,
    },
    '.DayPicker-Month': {
      marginTop: '0px',
    },
    '.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)': {
      backgroundColor: '#24242E',
    },
    '.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover': {
      backgroundColor: '#24242E',
    },
    '.DayPicker-Month select': {
      marginRight: '0px',
    },
  },
});
class DatePickerBase extends React.Component {
  constructor(props) {
    super(props);
    if (props.value != '') {
      const currentDate = this.getDateObj(props.value);
      this.state = {
        month: props.value && currentDate,
        displayMonth: props.value && currentDate,
      };
    } else if (props.to != null) {
      if (props.defaultYear) {
        this.state = {
          month: new Date(props.defaultYear, 0, 1),
          displayMonth: '',
        };
      } else {
        this.state = {
          month: new Date(props.to, 0, 1),
          displayMonth: '',
        };
      }
    } else {
      if (props.defaultYear) {
        this.state = {
          month: new Date(props.defaultYear, 0, 1),
          displayMonth: '',
        };
      } else {
        this.state = {
          month: '',
          displayMonth: '',
        };
      }
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      const newMonth = this.props.value ? this.getDateObj(this.props.value) : '';
      this.setState({ month: newMonth });
    }
  }

  getDateObj = value => {
    let currentDate = new Date(value);
    if (currentDate instanceof Date && isNaN(currentDate.getTime())) {
      currentDate = Moment(value, 'DD-MMM-YYYY').toDate();
    }
    return currentDate;
  };

  convertDate = day => {
    return Moment.utc(new Date(day)).format('DD-MMM-YYYY');
  };

  clearDate = () => {
    this.setState({ month: '' }, () => this.props.onChange(''));
  };

  handleYearMonthChange = month => {
    this.setState({ month, displayMonth: month });
  };

  handleDayChange = selectedDay => {
    if (selectedDay === undefined) return false;
    if (this.props.onChange) this.props.onChange(this.convertDate(selectedDay));
  };

  render() {
    const { className, classes, onChange, from, to, defaultYear, value,disabled, ...otherProps } = this.props;
    return (
      <DayPickerInput
        classNames={{
          container: className,
          overlay: classes.overlay,
        }}
        inputProps={{disabled:disabled}}
        component={DatePickerInput(() => this.datePicker, {
          clearDate: this.clearDate,disabled,
          ...otherProps,
        })}
        ref={el => (this.datePicker = el)}
        onDayChange={this.handleDayChange}
        dayPickerProps={{
          month: this.state.month || '',
          navbarElement: () => null,
          captionElement: ({ date, localeUtils }) => (
            <DatePickerHeader
              date={date}
              localeUtils={localeUtils}
              pickerRef={this.datePicker}
              onChange={this.handleYearMonthChange}
              from={from}
              to={to}
              defaultYear={defaultYear}
              value={value}
            />
          ),
        }}
        format={'DD-MMM-YYYY'}
        formatDate={formatDate}
        parseDate={parseDate}
        placeholder={'DD-MMM-YYYY'}
        value={this.state.displayMonth}
      />
    );
  }
}

export { DatePickerBase };
export default styled(DatePickerBase)(styles);



// WEBPACK FOOTER //
// ./src/ui/library/DatePicker/DatePickerBase.js